export function getImageData(
  file: File,
): Promise<{ width: number; height: number }> {
  return new Promise((resolve) => {
    const img = document.createElement('img');
    const objUrl = URL.createObjectURL(file);
    img.onload = () => {
      resolve({
        width: img.naturalWidth,
        height: img.naturalHeight,
      });
      URL.revokeObjectURL(objUrl);
      img.remove();
    };
    img.src = objUrl;
    img.onerror = () => {
      resolve({
        width: 0,
        height: 0,
      });
      URL.revokeObjectURL(objUrl);
      img.remove();
    };
  });
}
